export enum StoreType {
  ONLINE = 'ONLINE',
  PHYSICAL = 'OFFLINE',
  BOTH = 'ONLINE_AND_OFFLINE'
}
export interface IInfoBaseFormValues {
  firstName: string
  lastName: string
  nationalId: string
  email: string
  username: string
  type: StoreType
  userType: 'individual' | 'legal' | ''
  storeType: StoreType
  website: string
  shebaNumber: string
}

export interface IIndividualFormValues {
  businessLicenseNumber?: string
  licenseExpirationDate?: string | null
  licenseCategory?: string | null
  isicCode?: string
  storeName: string
}

export interface ILegalFormValues {
  companyNationalId: string
  companyEconomicCode?: string
  registrationNumber: string
  companyName: string
  storeBrandName: string
  signatoryOwners: string
}

export type TInfoFormValues = IInfoBaseFormValues &
  IIndividualFormValues &
  ILegalFormValues
